import * as React from 'react';

const ChequeRebrandingSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        viewBox="0 0 192 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0)">
            <path
                d="M0 16C0 7.16344 7.16344 0 16 0H176C184.837 0 192 7.16344 192 16V112C192 120.837 184.837 128 176 128H16C7.16344 128 0 120.837 0 112V16Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M176 4H16C9.37258 4 4 9.37258 4 16V112C4 118.627 9.37258 124 16 124H176C182.627 124 188 118.627 188 112V16C188 9.37258 182.627 4 176 4ZM16 0C7.16344 0 0 7.16344 0 16V112C0 120.837 7.16344 128 16 128H176C184.837 128 192 120.837 192 112V16C192 7.16344 184.837 0 176 0H16Z"
                fill="#E8E8E7"
            />
            <path
                d="M32 34C32 30.6863 34.6863 28 38 28H154C157.314 28 160 30.6863 160 34V94C160 97.3137 157.314 100 154 100H38C34.6863 100 32 97.3137 32 94V34Z"
                fill="#F5F5F0"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M154 32H38C36.8954 32 36 32.8954 36 34V94C36 95.1046 36.8954 96 38 96H154C155.105 96 156 95.1046 156 94V34C156 32.8954 155.105 32 154 32ZM38 28C34.6863 28 32 30.6863 32 34V94C32 97.3137 34.6863 100 38 100H154C157.314 100 160 97.3137 160 94V34C160 30.6863 157.314 28 154 28H38Z"
                fill="#D6CEC1"
            />
            <path d="M144 56H48V59H144V56Z" fill="#37322D" />
            <path d="M144 68H48V71H144V68Z" fill="#37322D" />
            <path d="M96 84H144V87H96V84Z" fill="#37322D" />
            <path
                d="M99.9982 78.7071L98.7062 79.9991L99.9982 81.2911L99.2911 81.9982L97.9991 80.7062L96.7071 81.9982L96 81.2911L97.292 79.9991L96 78.7071L96.7071 78L97.9991 79.292L99.2911 78L99.9982 78.7071Z"
                fill="#37322D"
            />
            <path
                d="M144 24.1818L135.818 16L112.909 38.909L108 52L121.091 47.0909L144 24.1818Z"
                fill="#324EFC"
            />
        </g>
        <defs>
            <clipPath id="clip0">
                <rect width="192" height="128" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

ChequeRebrandingSvg.displayName = 'ChequeRebrandingSvg';
export default ChequeRebrandingSvg;
